module.exports = __webpack_public_path__ + "img/matching-identifiers.2f00a6c2.svg";